import(/* webpackMode: "eager" */ "/app/dashboard/app/error.tsx");
